export default "__VITE_ASSET__d7c08170__"